import { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { useSiteConfigDispatch } from '../../context/SiteConfigContext';
import { useBuilder } from '../../context/BuilderContext';
import { useT } from '../../hooks/useT';
import BlockPickerModal from './BlockPickerModal';
import styles from './BlockInserter.module.css';

function BlockInserter({ pageKey, insertIndex }) {
  const [showPicker, setShowPicker] = useState(false);
  const dispatch = useSiteConfigDispatch();
  const { selectBlock } = useBuilder();
  const t = useT();

  const handleSelect = (block) => {
    dispatch({ type: 'ADD_BLOCK', pageKey, insertIndex, block });
    selectBlock(block.id, pageKey);
  };

  return (
    <div className={styles.inserter}>
      <div className={styles.line} />
      <button
        type="button"
        className={styles.addBtn}
        onClick={() => setShowPicker(true)}
        aria-label={t('editor.addBlockHere', 'Add block here')}
        title={t('editor.addBlockHere', 'Add block here')}
      >
        <FaPlus />
      </button>
      <div className={styles.line} />
      {showPicker && (
        <BlockPickerModal
          onSelect={handleSelect}
          onClose={() => setShowPicker(false)}
        />
      )}
    </div>
  );
}

export default BlockInserter;
